import type { ComponentProps } from 'react';

import { cn } from '@/lib/design-system/cn';

export type InputProps = ComponentProps<'input'> & {
  label?: string;
  hint?: string;
  error?: string;
};

export function Input({ label, hint, error, className, id, ...props }: InputProps) {
  const inputId = id ?? (label ? label.replace(/\s+/g, '-').toLowerCase() : undefined);

  return (
    <label className="flex flex-col gap-1" htmlFor={inputId}>
      {label ? <span className="cs-text-label">{label}</span> : null}
      <input
        id={inputId}
        className={cn('cs-input', error && 'border-danger', className)}
        {...props}
      />
      {error ? <span className="cs-text-caption text-danger">{error}</span> : null}
      {!error && hint ? <span className="cs-text-caption">{hint}</span> : null}
    </label>
  );
}
